import React, { Component } from "react";
import { observer } from "mobx-react"

import { QuizObjectFact } from "../../../../../../store/modquiz/quiz_objects/quiz-object";
import FactRow from './FactRow';
import FactsHeader from './FactsHeader';
import Button from '@mui/material/Button';

interface FactTableProps {
    facts: Array<QuizObjectFact>;
    focusField: Function
    blurField: (event: React.FocusEvent<HTMLInputElement>) => void;
    onFactTableUpdate: (
        event: React.ChangeEvent<HTMLInputElement>,
        factID: string,
        factOrder: number
    ) => void;
    onRowAdd: (
        event?:
            | React.MouseEvent<Element, MouseEvent>
            | React.KeyboardEvent<Element>
    ) => void;
    onRowDel: Function;
    onRowUndel: Function;
}

class FactTable extends Component<FactTableProps, any> {
    render() {
        let onFactTableUpdate = this.props.onFactTableUpdate;

        let component = this;

        let facts = this.props.facts.map(function(fact, i) {
            return (
                <FactRow
                    onFactTableUpdate={onFactTableUpdate}
                    fact={fact}
                    onDelEvent={component.props.onRowDel}
                    onUnDelEvent={component.props.onRowUndel}
                    rowNumber={i}
                    key={i}
                    focusField={component.props.focusField}
                    blurField={component.props.blurField}
                />
            );
        });

        return (
            <div>
                <br />
                <FactsHeader />
                <table className="table table-bordered fact-table">
                    <thead>
                        <tr>
                            <th>Fact Name</th>
                            <th>Fact Value</th>
                        </tr>
                    </thead>
                    <tbody>{facts}</tbody>
                </table>
                <Button
                    onClick={this.props.onRowAdd}
                    color="primary"
                >
                    + Fact
                </Button>
            </div>
        );
    }
}

export default observer(FactTable);
